module.exports = __webpack_public_path__ + "static/jun_avatar-910788125eac14a188d33197c86896e6.png";